function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
/** Implementation of the debounce function */

export const debounce = (func, wait) => {
  let timeout;

  function innerFunc(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  }

  return innerFunc;
};
/** Returns a subset of the given object including only the given keys, with values optionally replaced by a fn. */

export const selectKeys = (obj, keys, fn = val => val) => keys.reduce((values, key) => _objectSpread({}, values, {
  [key]: fn(obj[key])
}), {});
/** Returns a subset of the given object with a validator function applied to its keys. */

export const filterKeys = (obj, validator) => selectKeys(obj, Object.keys(obj).filter(validator));
/** Returns a subset of the given object with the given keys left out. */

export const excludeKeys = (obj, keys) => filterKeys(obj, key => !keys.includes(key));
/** Returns the given React children prop as a regular array of React nodes. */

export const childrenToArray = children => children && React.Children.count(children) > 0 && React.Children.toArray(children);
/** Returns true if the component has the desired displayName value */

export const hasDisplayName = (component, displayName) => component && component.type && component.type.displayName === displayName;
export const noop = Function.prototype;
export const helpers = {
  debounce,
  selectKeys,
  filterKeys,
  excludeKeys,
  childrenToArray,
  hasDisplayName,
  noop
};
export default helpers;